import { render, staticRenderFns } from "./VvlogItem.vue?vue&type=template&id=513fb0d0&scoped=true&"
import script from "./VvlogItem.vue?vue&type=script&lang=js&"
export * from "./VvlogItem.vue?vue&type=script&lang=js&"
import style0 from "./VvlogItem.vue?vue&type=style&index=0&id=513fb0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fb0d0",
  null
  
)

export default component.exports